import React, { useState } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { ClickOutDropDown } from '../../../components/DropDown/ClickOutDropDown';
import BookIcon from '../../../components/Icons/BookIcon';
import { ChevronDown } from '../../../components/Icons/ChevronDown';
import UploadIcon from '../../../components/Icons/UploadIcon';
import { Modal } from '../../../components/Modal/Modal';
import UploadTripLogExcelFileModal from '../../../components/Modal/ModalActions/UploadTripLogExcelFileModal/UploadTripLogExcelFileModal';
import { ADDRESS_BOOK, TRIP_LOG } from '../../../routes/routeConstants';

const LogManagement = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  return (
    <Container>
      <ClickOutDropDown
        posRight='0px'
        maxHeight='170px'
        label={
          <DropDownLabel>
            Log Management <ChevronDown />
          </DropDownLabel>
        }
      >
        <DropDownContent>
          <DivCell
            onClick={() => {
              setShowModal(true);
            }}
          >
            <UploadIcon /> Bulk Upload
          </DivCell>

          <DivCell onClick={() => navigate(`/${TRIP_LOG}/${ADDRESS_BOOK}`)}>
            <BookIcon /> View Address Book
          </DivCell>
        </DropDownContent>
      </ClickOutDropDown>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <UploadTripLogExcelFileModal />
      </Modal>
    </Container>
  );
};

export default LogManagement;

const Container = styled.div``;

const DropDownLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #5b91f5;
  border: 1px solid #5b91f5;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
`;

const DropDownContent = styled.div`
  display: flex;
  flex-direction: column;

  background-color: white;
  padding: 4px 0;
  gap: 4px;

  width: 283px;
`;

const DivCell = styled.div`
  padding: 13px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;

  &:hover {
    background-color: #f9fafb;
  }
`;
